import { useEffect } from "react";
import { useDisclosure } from "@chakra-ui/react";
import { Button } from "design-system";
import CaminoAnnounce from "components/Icon/CaminoAnnounce";
import SendRemindersQueueModal from "features/SendMessage/Components/SendRemindersQueueModal";
import { useCheckpointStakeholderGroups } from "features/Resources/Checkpoint/hooks";
import type { NewHireJourney } from "models/v2/newHireJourney";

interface CheckpointSendRemindersButtonProps {
  status: string;
  newHireJourney: NewHireJourney | undefined;
  results: { tasks?: { id: number }[] } | undefined;
  defaultOpen?: boolean;
}

export default function CheckpointSendRemindersButton({
  status,
  newHireJourney,
  results,
  defaultOpen = false,
}: CheckpointSendRemindersButtonProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    if (defaultOpen && (status === "partial" || status === "behind")) {
      onOpen();
    }
  }, [defaultOpen, status, onOpen]);

  const showButton = status === "partial" || status === "behind";

  const { rows, youRow } = useCheckpointStakeholderGroups(newHireJourney, results, { enabled: isOpen });

  if (!showButton) return null;

  return (
    <>
      <Button
        intent={Button.intent.primary}
        variant={Button.variant.solid}
        size="sm"
        leftIcon={{ customIcon: <CaminoAnnounce /> }}
        onClick={onOpen}
      >
        Send Reminders
      </Button>

      <SendRemindersQueueModal
        isOpen={isOpen}
        onClose={onClose}
        rows={rows}
        youRow={youRow}
        newHireJourneyId={newHireJourney?.id as string}
        newHire={
          newHireJourney?.newHire
            ? {
                fullName: newHireJourney.newHire.fullName,
                avatarUrl: newHireJourney.newHire.avatarUrl,
                title: newHireJourney.newHire.title,
                startDate: newHireJourney.startDate,
              }
            : undefined
        }
      />
    </>
  );
}
